import React from 'react'
import { useSelector } from 'react-redux'
import Link from 'next/link'

import { showNotYetPaidModalSelector } from 'app/selectors'
import { Modal } from 'controls'
import { Card } from 'components'
import { colors, measurements } from 'theme'
import { image } from 'services'
import config from 'config'

import RegisterNewDevice from 'components/Forms/UserSessionForm/RegisterNewDevice'
import LogoutSessions from 'components/UserSession/LogoutSessions'
import RevalidateSession from 'components/Forms/UserSessionForm/RevalidateSession'
import { companyConfig } from 'globalConfigApp'

import { userSessionModalStyles } from './styles'
import classNames from 'classnames'

const COMPANY_NAME = config('COMPANY_NAME')

const UserSessionModalContent = ({
  newDevice,
  excededDevices,
  shouldBeRevalidated,
}) => {
  if (newDevice) {
    return <RegisterNewDevice />
  }
  if (excededDevices) {
    return <LogoutSessions />
  }
  if (shouldBeRevalidated) {
    return <RevalidateSession />
  }
  return null
}

const UserSessionModal = () => {
  const showNotYetPaidModal = useSelector(showNotYetPaidModalSelector)
  const {
    excededDevices,
    fingerprint,
    newDevice,
    shouldBeLogout,
    refreshTokenWithTokenAndCreateSessionFeedback,
    shouldBeRevalidated,
  } = useSelector(state => state.userSession)

  if (
    !showNotYetPaidModal &&
    !refreshTokenWithTokenAndCreateSessionFeedback?.loading &&
    (newDevice || excededDevices || shouldBeRevalidated)
  ) {
    return (
      <Modal
        overlayStyle={{ backgroundColor: colors.frame }}
        isOpen={!showNotYetPaidModal}
        showCloseButton={false}
      >
        <Card
          rounded
          alignLeft
          data-qa="user-session-modal-container"
          maxWidth={measurements.containerMediumSize}
          style={{ margin: 0 }}
        >
          <div
            className={classNames('user-session-modal-body', {
              iad: COMPANY_NAME === 'IAD',
            })}
          >
              <a href="/" target="_blank">
                <img
                  src={image('logo-white.svg')}
                  alt={companyConfig.name}
                  className={classNames("logo", {
                    'iad': COMPANY_NAME === 'IAD'
                  })}
                />
              </a>
            <UserSessionModalContent
              newDevice={newDevice}
              excededDevices={excededDevices}
              shouldBeRevalidated={shouldBeRevalidated}
            />
          </div>
        </Card>

        <style jsx>{userSessionModalStyles}</style>
      </Modal>
    )
  }

  return null
}

export default UserSessionModal
